import React from 'react';
import Item from '../DropdownItem/DropdownItem';
import {
    IconContentL,
    IconHeartMessageL,
    IconPencilLetterL,
    IconPresentL,
    IconQuestionCircleL,
} from '../../../../icons';

export default () => (
    <>
        <Item name="FlipAndWin">
            <Item.Icon>
                <IconPresentL />
            </Item.Icon>
            <Item.Content>
                <Item.Heading>Flip & Win</Item.Heading>
                <Item.Description>Credits & Preise gewinnen</Item.Description>
            </Item.Content>
        </Item>
        <Item name="FindHorsePage" externalUrl="https://www.facebook.com/groups/436632103052370">
            <Item.Icon>
                <IconHeartMessageL />
            </Item.Icon>
            <Item.Content>
                <Item.Heading>Community</Item.Heading>
                <Item.Description>Exklusive Facebook-Gruppe</Item.Description>
            </Item.Content>
        </Item>
        <Item name="BlogPage" externalUrl="https://www.horsedeal.com/blog">
            <Item.Icon>
                <IconContentL />
            </Item.Icon>
            <Item.Content>
                <Item.Heading>Blog</Item.Heading>
                <Item.Description>Tipps, Tricks & News</Item.Description>
            </Item.Content>
        </Item>
        <Item name="CommunityPage">
            <Item.Icon>
                <IconPencilLetterL />
            </Item.Icon>
            <Item.Content>
                <Item.Heading>Richtlinien</Item.Heading>
                <Item.Description>Unsere Richtlinien</Item.Description>
            </Item.Content>
        </Item>
        <Item name="SupportPage" externalUrl="https://www.horsedeal.com/support">
            <Item.Icon>
                <IconQuestionCircleL />
            </Item.Icon>
            <Item.Content>
                <Item.Heading>Fragen & Antworten</Item.Heading>
                <Item.Description>Schnelle Hilfe finden</Item.Description>
            </Item.Content>
        </Item>
    </>
);
